// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		loadProductFirst: true,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style3',
		showLimitList: '12,24,48,70'
	},
	selector: {
		trackingQuickView: '.quick_shop'
	}
};


(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		saleText = "",
		discountAmount = "",
		changePrice = false,
		images = [],
		boostPFSRangeWidths = [165, 228],
		boostPFSScreenWidths = [165, 768];
		//boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];

	BoostPFS.inject(this);

	var filterTree = document.querySelector('.boost-pfs-filter-tree');

	/*FilterMobileButton.prototype.onClick = function(event) {
		console.log(event);
		filterTree.classList.add('is-opened');
	}*/

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		saleText = "";
		changePrice = false;

		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		// Add product form
		itemHtml = itemHtml.replace(/{{itemAddToCartForm}}/g, buildForm(data));

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add custom sale Label
		itemHtml = itemHtml.replace(/{{customSaleLabel}}/g, buildCustomSaleLabel(data));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		//Add Handle
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		//Add Sku
		itemHtml = itemHtml.replace(/{{itemSku}}/g, data.skus[0]);
		// Add Price
		itemHtml = itemHtml.replace(/{{itemFavouritesIcon}}/g, buildFavouritesIcon());

		itemHtml = itemHtml.replace(/{{itemStickers}}/g, buildStickers(data, "stickers-desktop"));
		itemHtml = itemHtml.replace(/{{itemStickersMobile}}/g, buildStickers(data, "stickers-mobile"));


		let mobileActionBtns = "";
		let jsTriggerProductFormMobile = '<div class="js-trigger-product-form-mobile">' +
		'<svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_6402_27387)"><rect width="21.6473" height="19.0259" transform="translate(0.928711 0.5)" fill="#3B3C40"/><path d="M7.9032 13.184H7.90405C7.90405 13.184 7.90574 13.184 7.90658 13.184H19.405C19.6883 13.184 19.9369 12.9962 20.0147 12.724L22.5515 3.84518C22.606 3.65366 22.568 3.44818 22.4479 3.2892C22.3278 3.13023 22.1405 3.03679 21.9414 3.03679H6.44074L5.9875 0.996789C5.92281 0.706749 5.66575 0.5 5.36852 0.5H1.56291C1.21241 0.5 0.928711 0.783698 0.928711 1.1342C0.928711 1.4847 1.21241 1.7684 1.56291 1.7684H4.85947C4.9398 2.12989 7.02885 11.5317 7.14935 12.0724C6.47541 12.3654 6.00272 13.0373 6.00272 13.8182C6.00272 14.8671 6.85635 15.7208 7.90531 15.7208H19.405C19.7555 15.7208 20.0392 15.4371 20.0392 15.0866C20.0392 14.7361 19.7555 14.4524 19.405 14.4524H7.90489C7.55524 14.4524 7.27069 14.1678 7.27069 13.8182C7.27069 13.4685 7.55439 13.1848 7.9032 13.184ZM21.1009 4.30519L18.9264 11.9156H8.41352L6.72232 4.30519H21.1009Z" fill="white"/><path d="M7.27051 17.6235C7.27051 18.6725 8.12414 19.5261 9.1731 19.5261C10.2221 19.5261 11.0757 18.6725 11.0757 17.6235C11.0757 16.5746 10.2221 15.7209 9.1731 15.7209C8.12414 15.7209 7.27051 16.5746 7.27051 17.6235ZM9.1731 16.9893C9.52276 16.9893 9.8073 17.2739 9.8073 17.6235C9.8073 17.9732 9.52276 18.2577 9.1731 18.2577C8.82345 18.2577 8.5389 17.9732 8.5389 17.6235C8.5389 17.2739 8.82345 16.9893 9.1731 16.9893Z" fill="white"/><path d="M16.2339 17.6235C16.2339 18.6725 17.0875 19.5261 18.1365 19.5261C19.1854 19.5261 20.0391 18.6725 20.0391 17.6235C20.0391 16.5746 19.1854 15.7209 18.1365 15.7209C17.0875 15.7209 16.2339 16.5746 16.2339 17.6235ZM18.1365 16.9893C18.4861 16.9893 18.7707 17.2739 18.7707 17.6235C18.7707 17.9732 18.4861 18.2577 18.1365 18.2577C17.7868 18.2577 17.5023 17.9732 17.5023 17.6235C17.5023 17.2739 17.7868 16.9893 18.1365 16.9893Z" fill="white"/><path d="M13.8986 11.4396C13.5005 11.4396 13.3015 11.3201 13.3015 11.0813V9.26589H11.4861C11.2472 9.26589 11.1278 9.06683 11.1278 8.66872V8.58512C11.1278 8.18701 11.2472 7.98795 11.4861 7.98795H13.3015V6.14868C13.3015 5.90981 13.5005 5.79038 13.8986 5.79038H14.0659C14.464 5.79038 14.663 5.90981 14.663 6.14868V7.98795H16.5023C16.7412 7.98795 16.8606 8.18701 16.8606 8.58512V8.66872C16.8606 9.06683 16.7412 9.26589 16.5023 9.26589H14.663V11.0813C14.663 11.3201 14.464 11.4396 14.0659 11.4396H13.8986Z" fill="white"/></g><defs><clipPath id="clip0_6402_27387"><rect width="21.6473" height="19.0259" fill="white" transform="translate(0.928711 0.5)"/></clipPath></defs></svg>' +
	  	'</div>';
		let shopboxViewSimilar = '<p class="button sb-findsim-v2 view-similar-btn-mobile" data-sku="[[itemUrl]]">' +
		'<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.9285 7.25122C19.9285 5.33343 19.1815 3.53046 17.8257 2.17434C16.4693 0.818506 14.6664 0.0715332 12.7486 0.0715332C10.8309 0.0715332 9.02792 0.818506 7.67182 2.17434C6.72488 3.12129 6.07575 4.28606 5.7696 5.55557C4.50011 5.86144 3.33536 6.51087 2.38842 7.45782C1.03261 8.81394 0.285645 10.6169 0.285645 12.5347C0.285645 14.4525 1.03261 16.2555 2.38842 17.6116C3.74452 18.9677 5.54747 19.7144 7.46523 19.7144C9.38299 19.7144 11.1859 18.9674 12.542 17.6116C13.489 16.6646 14.1381 15.4999 14.4443 14.2304C15.7137 13.9245 16.8788 13.2751 17.8254 12.3281C19.1815 10.972 19.9282 9.16901 19.9282 7.25122H19.9285ZM7.46523 18.5637C4.14102 18.5637 1.43659 15.8593 1.43659 12.535C1.43659 9.86764 3.17768 7.59996 5.58286 6.80753C5.57394 6.95485 5.56876 7.10275 5.56876 7.25151C5.56876 9.1693 6.31572 10.9723 7.67153 12.3284C9.02763 13.6845 10.8306 14.4312 12.7483 14.4312C12.8971 14.4312 13.0453 14.4263 13.1923 14.4171C12.3999 16.8223 10.132 18.5634 7.46494 18.5634L7.46523 18.5637ZM13.4939 12.535C13.4939 12.7732 13.4795 13.008 13.4524 13.2391C13.2214 13.2661 12.9866 13.2805 12.7483 13.2805C11.232 13.2805 9.84509 12.7177 8.7845 11.7903H13.4478C13.478 12.0343 13.4939 12.2829 13.4939 12.5353V12.535ZM7.7639 10.6391C7.45285 10.1827 7.20281 9.68176 7.02557 9.14771H12.45C12.761 9.60407 13.011 10.105 13.1883 10.6391H7.76418H7.7639ZM6.76574 7.99676C6.73553 7.75246 6.7197 7.50386 6.7197 7.25151C6.7197 7.01326 6.73409 6.77846 6.76114 6.54741C6.99219 6.52036 7.22698 6.50597 7.46523 6.50597C8.9816 6.50597 10.3691 7.06908 11.4297 7.99676H6.76603H6.76574ZM14.6307 12.979C14.6396 12.8316 14.6448 12.6838 14.6448 12.5347C14.6448 10.6169 13.8978 8.81394 12.542 7.45782C11.1862 6.1017 9.38299 5.35501 7.46523 5.35501C7.31647 5.35501 7.16828 5.35991 7.02125 5.36911C7.81367 2.9639 10.0816 1.22278 12.7486 1.22278C16.0728 1.22278 18.7773 3.92725 18.7773 7.25151C18.7773 9.91886 17.0362 12.1865 14.631 12.979H14.6307Z" fill="#009FE3"/></svg></p>';

		if(window.innerWidth < 1024) {
			mobileActionBtns = '<div class="mobile-action-buttons">' +
			jsTriggerProductFormMobile +
			shopboxViewSimilar +
		  '</div>';
		} else {
			// Mobile action buttons need to be always present, or they will disappear on resize.
			// However Shopbox can't handle two buttons, so we don't generate shopbox "view similar" btn on desktop.
			mobileActionBtns = '<div class="mobile-action-buttons">' +
			jsTriggerProductFormMobile +
		  '</div>';
		}

		// Add mobile actions buttons
		itemHtml = itemHtml.replace(/{{mobileActionBtns}}/g, mobileActionBtns);

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};

	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add custom sale Label
		itemHtml = itemHtml.replace(/{{customSaleLabel}}/g, buildCustomSaleLabel());
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		// Add product form
		itemHtml = itemHtml.replace(/{{itemAddToCartForm}}/g, buildForm(data));


		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	}

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildImages(data) {
		var html = '',
			rangeWidths = boostPFSRangeWidths,
			screenWidths = boostPFSScreenWidths;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 && boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + screenWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + screenWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (images.length > 0) {
			html += '<div class="product-card__image-wrapper relative w-full overflow-hidden';
			if (boostPFSThemeConfig.custom.show_secondary_image == true) {
				html +=	' hover-effect';
			}
			if (boostPFSThemeConfig.custom.image_ratio==='square' ) {
				html +=	' aspect-w-1 aspect-h-1';
			} else {
				html +=	' aspect-w-8 aspect-h-12';
			}
			html +=	'">';

			html += '<img class="product-card__image w-full h-full object-center transition-all duration-300';
			if (boostPFSThemeConfig.custom.image_ratio === 'square' ) {
				html +=	' object-cover';
			} else {
				html +=	' object-contain';
			}
			html +='" loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].height + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';

			if (activeSwapImage) {
				html += '<img class="product-card__image w-full h-full object-center transition-all duration-300';
				if (boostPFSThemeConfig.custom.image_ratio === 'square' ) {
					html +=	' object-cover';
				} else {
					html +=	' object-contain';
				}
				html +='" loading="lazy"' +
					'srcset="' + flipImageSrcSet + '" ' +
					'height="' + images[1].height + '" ' +
					'width="' + images[1].width + '" ' +
					'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
					'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
					'alt="' + imgAlt + '" />';
			}

			html += '</div>';
		} else {
			html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
		}
		return html;
	}

	function getHomeDeliveryQuantity(data) {
		var homeDeliveryQuantity = 0;

		for (i in data.metafields) {
			if (data.metafields[i].key === 'stock_branches') {
				metafieldValue = JSON.parse(data.metafields[i].value,);
			}
		}
		if (metafieldValue) {
			var metafieldValueLength = Object.keys(metafieldValue).length;
			if (metafieldValueLength >= 1) {
				for (let i in metafieldValue) {
					var stores = metafieldValue[i];

					for (let s in stores) {
						var store = stores[s];

						if (store.location === 'HEA') {
							homeDeliveryQuantity = store.qty;
						}
					}
				}
			}
		}

		return homeDeliveryQuantity;
	}

	function getHomeDeliveryQuantityBySKU(data, sku) {
		var homeDeliveryQuantity = 0;

		for (i in data.metafields) {
			if (data.metafields[i].key === 'stock_branches') {
				metafieldValue = JSON.parse(data.metafields[i].value);
			}
		}
		if (metafieldValue) {
			var metafieldValueLength = Object.keys(metafieldValue).length;
			var metafieldValueBySku = metafieldValue[sku];
			if (!metafieldValue[sku]) return null;

			var stores = metafieldValueBySku;

			for (let s in stores) {
				var store = stores[s];

				if (store.location === 'HEA') {
					homeDeliveryQuantity = store.qty;
				}
			}
		}

		return homeDeliveryQuantity;
	}

	function buildForm(data) {
		let html = boostPFSTemplate.productFormHtml;
		let addToCartFormClass = "";
		let viewProductClass = "";
		let variantSelect = "";
		let addToCartBtnClass = "";
		let qtyClass = "";
		let showForm = false;
		let showFormClass = "";
		let showFormBtn = "";
		let submitBtnDisabledAtt = "";
		let addToCartBlockClass = "";
		let variantSelectMobile = "";
		let lineAttributes = "";
		let addToCartIcon = '<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.02602 13C6.15935 13 5.72602 12.74 5.72602 12.22V8.268H1.77402C1.25402 8.268 0.994021 7.83467 0.994021 6.968V6.786C0.994021 5.91933 1.25402 5.486 1.77402 5.486H5.72602V1.482C5.72602 0.961999 6.15935 0.701999 7.02602 0.701999H7.39002C8.25669 0.701999 8.69002 0.961999 8.69002 1.482V5.486H12.694C13.214 5.486 13.474 5.91933 13.474 6.786V6.968C13.474 7.83467 13.214 8.268 12.694 8.268H8.69002V12.22C8.69002 12.74 8.25669 13 7.39002 13H7.02602Z" fill="#009FE3"/></svg>';
		html = html.replace(/{{itemId}}/g, data.id);

		if (!data.tags.find((tag) => tag === 'backorder:off')) {
			lineAttributes += '<input type="hidden" name="properties[Product Note]" value="' + boostPFSThemeConfig.label.backorder_message + '"/>'
		}

		// if(window.innerWidth < 1024) { Behaviours were changed so now desktop uses similar overlay to mobile
		// However, this class still needs to be present or the desktop overlays will all appear on mobile.
			addToCartBlockClass = "hidden";
		// }

		// Advanced multibuys
		let hascheapestfree = false,
			properties = '',
			property_fields = '';
		if(Shopify.theme.settings.enable_promotion_advanced_multibuy) {
			const cheapestfree = data.tags.filter((tag) => tag.includes(boostPFSThemeConfig.custom.advanced_multibuys_tag));
			if (cheapestfree.length > 0) {
				const tag = cheapestfree[0],
					promotion = tag.replace(boostPFSThemeConfig.custom.advanced_multibuys_tag, '').split(':'),
					[promo_id, promo_min, promo_discounted, promo_discount] = promotion,
					promo_description = getAdvancedMultibuysLabel(tag);
				hascheapestfree = true;
				properties = JSON.stringify({
					'_promotion': tag,
					'_promotion_description': promo_description,
					'_promotion_id': promo_id
				});
				property_fields = `<input type="hidden" name="properties[_promotion]" value="${tag}">
					<input type="hidden" name="properties[_promotion_description]" value="${promo_description}">
					<input type="hidden" name="properties[_promotion_id]" value="${promo_id}">`
			}
		}
		html = html.replace(/{{advancedMultibuysProperties}}/g, (properties.length > 0 ? `data-properties='${properties}'` : ''));
		html = html.replace(/{{advancedMultibuysFields}}/g, (property_fields.length > 0 ? property_fields : ''));
		// End advanced multibuys

		// line item property for home delivery quantity (used in checkout)
		let homeDeliveryQuantity = getHomeDeliveryQuantity(data);
		let homeDeliveryQuantityField = '<input type="hidden" name="properties[_home_delivery_quantity]" value="' + homeDeliveryQuantity + '"><input type="hidden" name="properties[_tags]" value="homeDeliveryQuantity-' + homeDeliveryQuantity + '">';

		// Data unavailable?
		if (data.available == false && data.variants.length == 1) {
			addToCartFormClass = "hidden";
		// One Variant
		} else if (data.variants.length == 1 ) {
			variantSelect = '<input type="hidden" name="id" value="' + data.variants[0].id + '" class="original-selector">';
			viewProductClass = "hidden";
			variantSelectMobile = '<form method="post" action="/cart/add" id="product_form_mobile_' + data.id +'" accept-charset="UTF-8" class="shopify-product-form product-form-mobile-quick-add" enctype="multipart/form-data" data-product-id="' + data.id +'">' +
			  '<input type="hidden" name="form_type" value="product">' +
			  '<input type="hidden" name="utf8" value="✓">' +
			  '<input type="hidden" name="quantity" class="product-page__quantity-input"  placeholder="1" value="1">' +
			  '<input type="hidden" name="id" value="' + data.variants[0].id + '" class="original-selector">' +
			  '<button class="add-to-cart-button button button--large add-to-cart-button add-to-cart-button-collection" data-add-to-cart {{submitBtnDisabledAtt}}>' +
              '<span>ADD TO CART</span>' +
			  addToCartIcon +
			  '</button>' +
				property_fields +
				(data.tags.includes('backorder:off') ? homeDeliveryQuantityField : '') +
			  '</form>';
		// Multiple variants
		} else if (data.variants.length > 1) {
			if (data.available == false) {
				addToCartBtnClass = "hidden";
				addToCartFormClass = "hidden";
			} else {
				viewProductClass = "hidden";
				showForm = true;
				submitBtnDisabledAtt = "disabled";
			}

			let optionsHeading = "";
			// Options exist - Create options headings - DESKTOP
			if (data.options.length > 0) {
				let optionsTitle = ""; // Unused value??
				data.options.forEach(option => {
					optionsTitle = optionsTitle + ' & ' + option;
				})
				optionsHeading = '<p class="product-card--options--title">Select:</p>';
			}

			// Multi Options
			if (data.options.length > 1) {
				let variantOptions = "";

				data.variants.forEach(variant => {
					let optionAttr = "";
					data.options.forEach((option, index) => {
						optionAttr = optionAttr + ' data-option--' + option + '="' + variant.options[index] + '"';
					})

					homeDeliveryQuantity = getHomeDeliveryQuantityBySKU(data, variant.sku);

					let option = '<option data-home-delivery-qty="' + homeDeliveryQuantity + '" value="' + variant.id + '"' +
									(variant.available ? "" : ' disabled ') +
									optionAttr +
								'>'+
								variant.title +
								'</option>';

					variantOptions = variantOptions + option;


				});
				let variantSelectMain = '<select name="id" class="product-card--variants-select product-select-variant">' +
										variantOptions +
									'</select>';

				let selects = "";
				data.options_with_values.forEach((option, index) => {
					let optionVariants = "";
					option.values.forEach(value => {
						optionVariants = optionVariants + '<option' + (index != 0 ? " disabled" : "") +'>' + value.title + '</option>';
					});

					let select = '<div class="product-card--option">' +
					            	'<div class="product-card--option-dropdown">' +
										'<select name="options[' + option.name +']" data-option-title="' + option.name +'"  class="product-card--option-select outline-none appearance-none">' +
											'<option selected disabled hidden>' + option.name +'</option>' +
											optionVariants +
										'</select>' +
										'<div class="open-select"></div>' +
									'</div>' +
								'</div>';
					selects = selects + select;

				});
				let optionSelect = '<div class="product-card--options">' + selects + '</div>';
				variantSelect = optionsHeading + variantSelectMain + optionSelect;

				variantSelectMobile = '<form method="post" action="/cart/add" id="product_form_mobile_' + data.id +'" accept-charset="UTF-8" class="shopify-product-form product-form-quick-add product-form-mobile-quick-add" enctype="multipart/form-data" data-product-id="' + data.id +'">' +
						'<input type="hidden" name="form_type" value="product">' +
						'<input type="hidden" name="utf8" value="✓">' +
						'<input type="hidden" name="quantity" class="product-page__quantity-input"  placeholder="1" value="1">' +
						'<p class="product-card--options--title">Select</p>' +
						variantSelectMain + optionSelect +
						'<button class="add-to-cart-button button button--large add-to-cart-button add-to-cart-button-collection" data-add-to-cart {{submitBtnDisabledAtt}}>' +
						'<span>ADD TO CART</span>' +
						addToCartIcon +
						'</button>' +
						property_fields +
						(data.tags.includes('backorder:off') ? homeDeliveryQuantityField : '') +
						'</form>';

			} else if (data.options.length == 1) {
				// Single Option
				let options = "";

				// Check available variants
				let variantsAvailable = 0;
				data.variants.forEach(variant => {
					if (variant.available) {
						variantsAvailable++;
					}
				});

				// First option is size and max 3 options -> Finalizes Variantselect and Variantselectmobile
				if (data.options[0] == "size" && data.variants.length < 4) {
					let swatchVariantsModal = "";
					let mobileForms = "";
					let first_available = '';
					let counter = 0;
					let variantInput = '';
					data.variants.forEach(variant => {
						let checked = "";
						let disabled = "";
						let disabledHtml = "";
						if (!first_available && variant.available) {
							first_available = variant.id;
							checked = " checked ";
						}
						if (!variant.available) {
							disabled = " disabled ";
							disabledHtml = '<span class="out-of-stock">Out of stock</span>'
						}

						homeDeliveryQuantity = getHomeDeliveryQuantityBySKU(data, variant.sku);
						if (homeDeliveryQuantity) {
							homeDeliveryQuantityField = '<input type="hidden" name="properties[_home_delivery_quantity]" value="' + homeDeliveryQuantity + '"><input type="hidden" name="properties[_tags]" value="homeDeliveryQuantity-' + homeDeliveryQuantity + '">';
						} else {
							homeDeliveryQuantityField = "";
						}

						// Build Mobile Selector
						let form = '<form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form product-form-mobile-quick-add-size ' + disabled +'" enctype="multipart/form-data" data-product-id="' + data.id +'">' +
						'<input type="hidden" name="form_type" value="product">' +
						'<input type="hidden" name="utf8" value="✓">' +
						'<input type="hidden" name="quantity" class="product-page__quantity-input"  placeholder="1" value="1">' +
						'<input type="hidden" name="id" value="' + variant.id + '" class="original-selector">'+
						'<p class="variant-title-wrapper"><span class="variant-title">'+ variant.option_size + '</span>' + disabledHtml +'</p>' +
						'<button class="add-to-cart-button button button--large add-to-cart-button add-to-cart-button-collection" data-add-to-cart ' + disabled + ' ' + (properties.length > 0 ? `data-properties='${properties}'` : '') + '>' +
						'<span>ADD TO CART</span>' +
						addToCartIcon +
						'</button>' +
						property_fields +
						(data.tags.includes('backorder:off') ? homeDeliveryQuantityField : '') +
						'</form>';
						mobileForms = mobileForms + form;

						// Build Desktop Selector (Abandoned - Swatches side by side)
						/* Rita's implementation
						To Enable, setup variant select like so (look also for where variantSelectMobile is defined):
						`variantSelect = optionsHeading + '<div class="block-swatch-list">' + swatchVariantsModal + '</div>';`

						// Old Implementation here
						`let block_swatch_id = 'product_form_id_' + data.id + '--' + variant.id;

						let variantInput = '<div class="block-swatch">' +
							'<input class="block-swatch__radio product-form__single-selector" type="radio" name="id" id="' + block_swatch_id + '" value="' + variant.id + '"' + disabled + checked + '>' +
							'<label class="block-swatch__item" for="' + block_swatch_id + '" title="' + variant.id + '">' +
								'<span class="block-swatch__item-text">' + variant.option_size + '</span>' +
							'</label>' +
							'</div>';
						swatchVariantsModal = swatchVariantsModal + variantInput;`
						*/

						if (counter == 0) {
							swatchVariantsModal = swatchVariantsModal + '<form></form>';  // Hack to be removed when there is time to investigate. Extra form to avoid the main form being deleted by unknown entity
						}

						swatchVariantsModal = swatchVariantsModal + form;

						counter++;
					})

					variantSelect = optionsHeading + '<div class="block-swatch-list">' + swatchVariantsModal + '</div>';

					variantSelectMobile = '<div class="size-forms-wrapper">' +
						'<p class="product-card--options--title">Select Size</p>' +
						mobileForms +
						'</div>';
				} else {
					// First option not size, or 4+ options -> Finalizes Variantselect and Variantselectmobile
					data.variants.forEach(variant => {
						homeDeliveryQuantity = getHomeDeliveryQuantityBySKU(data, variant.sku);
						let optionHtml = '<option data-home-delivery-qty="' + homeDeliveryQuantity + '" value="' + variant.id + '" ' + (variant.available ? "" : 'disabled') + '>' + variant.title + '</option>';
						options = options + optionHtml;
					})
					homeDeliveryQuantity = getHomeDeliveryQuantityBySKU(data, data.variants[0].sku);
					homeDeliveryQuantityField = '<input type="hidden" name="properties[_home_delivery_quantity]" value="' + homeDeliveryQuantity + '"><input type="hidden" name="properties[_tags]" value="homeDeliveryQuantity-' + homeDeliveryQuantity + '">';
					let wrapper = '<div class="product-card--options"><div class="product-card--option">' +
						'<div class="product-card--option-dropdown">' +
							'<select name="id" class="product-card--option-select product-select-variant outline-none appearance-none">'+
								options +
							'</select>' +
							'<div class="open-select"></div>' +
						'</div>' +
					'</div></div>';
					variantSelect = optionsHeading + wrapper;
					variantSelectMobile = '<form method="post" action="/cart/add" id="product_form_mobile_' + data.id +'" accept-charset="UTF-8" class="shopify-product-form product-form-mobile-quick-add" enctype="multipart/form-data" data-product-id="' + data.id +'">' +
						'<input type="hidden" name="form_type" value="product">' +
						'<input type="hidden" name="utf8" value="✓">' +
						'<input type="hidden" name="quantity" class="product-page__quantity-input"  placeholder="1" value="1">' +
						'<p class="product-card--options--title">Select</p>' +
						wrapper +
						'<button class="add-to-cart-button button button--large add-to-cart-button add-to-cart-button-collection" data-add-to-cart ' + (properties.length > 0 ? `data-properties='${properties}'` : '') + ' {{submitBtnDisabledAtt}}>' +
						'<span>ADD TO CART</span>' +
						addToCartIcon +
						'</button>' +
						property_fields +
						(data.tags.includes('backorder:off') ? homeDeliveryQuantityField : '') +
						'</form>';
				}
				submitBtnDisabledAtt = "";
			}

		}

		if (showForm) {
			showFormClass = "product-form--modal hidden";
			addToCartBtnClass = "hidden";
			showFormBtn = '<p class="add-to-cart-button js-trigger-product-form"><span>QUICK ADD</span> <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">'+
			'<g clip-path="url(#clip0_6261_25419)">' +
			'<path d="M7.41031 13.4766H7.41121C7.41121 13.4766 7.41301 13.4766 7.41391 13.4766H19.6309C19.9318 13.4766 20.196 13.2771 20.2786 12.9878L22.9739 3.55422C23.0319 3.35072 22.9915 3.1324 22.8639 2.9635C22.7363 2.79459 22.5373 2.69531 22.3257 2.69531H5.85646L5.3749 0.527832C5.30617 0.219668 5.03305 0 4.71725 0H0.673828C0.301426 0 0 0.301426 0 0.673828C0 1.04623 0.301426 1.34766 0.673828 1.34766H4.17639C4.26174 1.73174 6.48133 11.721 6.60936 12.2956C5.8933 12.6069 5.39107 13.3207 5.39107 14.1504C5.39107 15.2649 6.29805 16.1719 7.41256 16.1719H19.6309C20.0033 16.1719 20.3047 15.8704 20.3047 15.498C20.3047 15.1256 20.0033 14.8242 19.6309 14.8242H7.41211C7.04061 14.8242 6.73828 14.5219 6.73828 14.1504C6.73828 13.7789 7.03971 13.4775 7.41031 13.4766ZM21.4327 4.04297L19.1223 12.1289H7.95252L6.15564 4.04297H21.4327Z" fill="#009FE3"/>'+
			'<path d="M6.73828 18.1934C6.73828 19.3079 7.64525 20.2148 8.75977 20.2148C9.87428 20.2148 10.7812 19.3079 10.7812 18.1934C10.7812 17.0788 9.87428 16.1719 8.75977 16.1719C7.64525 16.1719 6.73828 17.0788 6.73828 18.1934ZM8.75977 17.5195C9.13127 17.5195 9.43359 17.8219 9.43359 18.1934C9.43359 18.5649 9.13127 18.8672 8.75977 18.8672C8.38826 18.8672 8.08594 18.5649 8.08594 18.1934C8.08594 17.8219 8.38826 17.5195 8.75977 17.5195Z" fill="#009FE3"/>'+
			'<path d="M16.2617 18.1934C16.2617 19.3079 17.1687 20.2148 18.2832 20.2148C19.3977 20.2148 20.3047 19.3079 20.3047 18.1934C20.3047 17.0788 19.3977 16.1719 18.2832 16.1719C17.1687 16.1719 16.2617 17.0788 16.2617 18.1934ZM18.2832 17.5195C18.6547 17.5195 18.957 17.8219 18.957 18.1934C18.957 18.5649 18.6547 18.8672 18.2832 18.8672C17.9117 18.8672 17.6094 18.5649 17.6094 18.1934C17.6094 17.8219 17.9117 17.5195 18.2832 17.5195Z" fill="#009FE3"/>'+
			'<path d="M13.7805 10.9137C13.3575 10.9137 13.146 10.7868 13.146 10.533V8.60418H11.2172C10.9634 8.60418 10.8365 8.39268 10.8365 7.9697V7.88087C10.8365 7.45788 10.9634 7.24639 11.2172 7.24639H13.146V5.29218C13.146 5.03839 13.3575 4.91149 13.7805 4.91149H13.9582C14.3811 4.91149 14.5926 5.03839 14.5926 5.29218V7.24639H16.5468C16.8006 7.24639 16.9275 7.45788 16.9275 7.88087V7.9697C16.9275 8.39268 16.8006 8.60418 16.5468 8.60418H14.5926V10.533C14.5926 10.7868 14.3811 10.9137 13.9582 10.9137H13.7805Z" fill="#009FE3"/>'+
			'</g><defs><clipPath id="clip0_6261_25419"><rect width="23" height="20.2148" fill="white"/></clipPath></defs>'+
			'</svg></p>';
		} else {
			showFormClass = "hidden";
		}

		html = html.replace(/{{itemFirstVariantId}}/g, variantSelect);
		html = html.replace(/{{addToCartFormClass}}/g, addToCartFormClass);
		html = html.replace(/{{viewProductClass}}/g, viewProductClass);
		html = html.replace(/{{addToCartBtnClass}}/g, addToCartBtnClass);
		html = html.replace(/{{qtyClass}}/g, qtyClass);
		html = html.replace(/{{variantSelect}}/g, variantSelect);
		html = html.replace(/{{lineAttributes}}/g, lineAttributes);
		html = html.replace(/{{variantSelectMobile}}/g, variantSelectMobile);
		html = html.replace(/{{showFormClass}}/g, showFormClass);
		html = html.replace(/{{showFormBtn}}/g, showFormBtn);
		html = html.replace(/{{addToCartBlockClass}}/g, addToCartBlockClass);
		html = html.replace(/{{submitBtnDisabledAtt}}/g, submitBtnDisabledAtt);

		html = html.replace(/{{homeDeliveryQuantityField}}/g, data.tags.includes('backorder:off') ? homeDeliveryQuantityField : '');

		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else {
			html = 'card--outline';
		}
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') && boostPFSThemeConfig.custom.show_vendor === true) {
			html += '<p class="product-card__vendor mt-1 fontAsap font-normal text-xs ' +
				'lg:text-sm text-c_warm_black tracking-widest uppercase text-center">'
				+ data.vendor + '</p>'
		}
		return html;
	}

	function buildFavouritesIcon() {
		return `
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29" viewBox="0 0 25 29" fill="none">
        <mask id="mask0_92_582" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="2" width="25" height="26">
          <path d="M0 2.39014H25V27.3901H0V2.39014Z" fill="white"></path>
        </mask>
        <g mask="url(#mask0_92_582)">
          <path d="M21 23.5253V6.18653C21 4.64203 19.6877 3.38995 18.069 3.38995H6.93103C5.31227 3.38995 4 4.64203 4 6.18653V23.5415C4 24.6801 4.98683 25.4067 6.00287 25.3897C6.48005 25.3816 6.96362 25.225 7.35442 24.8418L12.5 19.7965L17.6456 24.8418C18.0364 25.225 18.52 25.3839 18.9971 25.3897C20.0132 25.4019 21 24.6639 21 23.5253Z" stroke="#009fe3" stroke-width="2.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>
      </svg>`
	}

	function buildPrice(data) {
		var moneyPrice = Utils.formatMoney(data.price_min);
		var priceClacess = '';
		var fontWeight;
		var html = '';
		if (soldOut) {
			priceClacess+= 'price--sold-out';
		}
		if(data.compare_at_price_min > data.price_min || changePrice ) {
			priceClacess+= ' price--on-sale';
			fontWeight = 'font-bold'
		} else {
			fontWeight = 'font-normal'
		}

		// if ( changePrice ) {
		// 	html += '<div class="product-card__price mt-2 text-base lg:text-lg text-c_warm_black text-center">' +
		// 	'<div class="price fontAsap '+ priceClacess +'">' +
		// 	'<span class="price__regular '+ fontWeight +'">' +
		// 	'<span class="visually-hidden visually-hidden--inline">'+ boostPFSConfig.label.regular_price +'</span>' +
		// 	'<span class="price-item price-item--regular">'+ (data.price_min != data.price_max ? '<small class="text-gray-600 font-normal italic">from </small>' : '') + Utils.formatMoney(Number(discountAmount)) +'</span>' +
		// 	'</span>'

		// 	html+='<span class="price__sale text-gray_4">' +
		// 		'<span class="visually-hidden visually-hidden--inline">'+ boostPFSConfig.label.sale_price +'</span>' +
		// 		'<span class="price__compare ml-2">' +
		// 		'<s class="price-item price-item--regular">'+ Utils.formatMoney(data.price_min) +'</s>' +
		// 		'</span>' +
		// 		'</span>'

		// }else {

			html += '<div class="product-card__price mt-2 text-base lg:text-lg text-c_warm_black text-center">' +
			'<div class="price fontAsap '+ priceClacess +'">' +
			'<span class="price__regular '+ fontWeight +'">' +
			'<span class="visually-hidden visually-hidden--inline">'+ boostPFSConfig.label.regular_price +'</span>' +
			'<span class="price-item price-item--regular">'+ (data.price_min != data.price_max ? '<small class="text-gray-600 font-normal italic">from </small>' : '') + moneyPrice +'</span>' +
			'</span>'

			if (data.compare_at_price_min > data.price_min) {
				html+='<span class="price__sale text-gray_4">' +
					'<span class="visually-hidden visually-hidden--inline">'+ boostPFSConfig.label.sale_price +'</span>' +
					'<span class="price__compare ml-2">' +
					'<s class="price-item price-item--regular">'+ Utils.formatMoney(data.compare_at_price_min) +'</s>' +
					'</span>' +
					'</span>'
			}
		// }

		html += '</div></div>'

		return html;
	}

	function getAdvancedMultibuysLabel(tag) {
		const stickerProperties = tag.replace(boostPFSThemeConfig.custom.advanced_multibuys_tag, '').split(':'),
			minimum = +stickerProperties[1],
			to_discount = +stickerProperties[2],
			discount_amount = +stickerProperties[3],
			pay_for = minimum - to_discount;
		let sticker_label = '';

		if(discount_amount == 100) {
			if(pay_for == to_discount) {
				sticker_label = `Buy ${pay_for} get ${to_discount} free`;
			} else {
				sticker_label = `Buy ${minimum} for ${pay_for}`;
			}
		} else if (discount_amount == 50) {
			sticker_label = `Buy ${minimum} get ${to_discount} half price`;
		} else {
			sticker_label = `Buy ${minimum} get ${to_discount} - ${discount_amount}% off`;
		}

		return sticker_label;
	}

	function buildStickers(data, customClass) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_stickers') && boostPFSThemeConfig.custom.show_stickers === true) {
			html+='<div class="product-card__stickers collection-product-card__stickers ' + customClass + '">'
			html += buildClickCollectSticker(data);
			for (tag of data.tags) {
				if (tag.includes('sticker')) {
					var stickerProperties = tag.split(':');
					html+='<div class="product-card__sticker" style="background-color:'+ stickerProperties[1] +'">' + stickerProperties[2] + '</div>'
				}
				if(boostPFSThemeConfig.custom.advanced_multibuys_enabled) {
					if(tag.includes(boostPFSThemeConfig.custom.advanced_multibuys_tag)) {
						const sticker_label = getAdvancedMultibuysLabel(tag);
						html+='<div class="product-card__sticker" style="background-color:#bf0712">' + sticker_label + '</div>'
					}
				}
			}
			if (boostPFSThemeConfig.label.backorder_message && !data.tags.includes('backorder:off')) {
				html += '<div class="product-card__sticker" style="background-color:">' + boostPFSThemeConfig.label.backorder_message + '</div>';
			}
			html+='</div>'
		}
		return html;
	}

	function buildClickCollectSticker(data) {
		var clickCollectSticker = false;
		var metafieldValue;
		var html = '';
		for (i in data.metafields) {
			if (data.metafields[i].key === 'stock_branches') {
				metafieldValue = JSON.parse(data.metafields[i].value,);
			}
		}
		if (metafieldValue) {
			var metafieldValueLength = Object.keys(metafieldValue).length;
			if (metafieldValueLength >= 1) {
				let heaLocationsInventory = [];
				for (let i in metafieldValue) {
					var stores = metafieldValue[i];

					for (let s in stores) {
						var store = stores[s];

						if (store.location === 'HEA' && store.qty < 1) {
							heaLocationsInventory.push(false);
						} else if (store.location === 'HEA' && store.qty > 0) {
							heaLocationsInventory.push(true);
						}
					}
				}
				let heaLocationsInventoryInStock = heaLocationsInventory.filter(stock => stock === true);
				if ( heaLocationsInventoryInStock.length < 1 ) {
					clickCollectSticker = true;
				}
			}
		}

		if (clickCollectSticker === true && data.tags?.includes('backorder:off')) {
			html+='<div class="product-card__sticker product-card__sticker_cc">'+ boostPFSThemeConfig.custom.cc_sticker_label +'</div>';
		}

		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}

	function formatDiscountValue(options = {}) {
		const { discountPrefix,
			discountSettings,
			price } = options;

		switch(discountPrefix) {
			case 'buy_x_get_y_free:':
				[ sku, quantity, free ] = discountSettings;
				return {
					text: `${quantity} for ${quantity - free}`,
					amount: 0,
					changePrice: false
				};

			case 'bulk_buy:':
				[ sku, quantity, value, type ] = discountSettings;
				if( type == "percent" ) {
					return {
						text: `Buy ${quantity} get ${value}% off`,
						amount: 100,
					changePrice: false
					};
				}
				return {
					text: `${quantity} for €${value}`,
					amount: value,
					changePrice: false
				};

			case 'discount_off:':
				[ sku, value, type ] = discountSettings;
				if( type == "percent" ) {
					return {
						text: `${value}% off`,
						amount: price - (price * 0.01 * parseFloat(value)),
						changePrice: true
					};
				}
				return {
					text: `€${value} off`,
					amount: price - parseFloat(value),
					changePrice: true
				};

			case 'discount_now:':
				[ sku, value ] = discountSettings;
				return {
					text: `Now €${value}`,
					amount: parseFloat(value),
					changePrice: true
				};

			default: return {};
		}
	}

	function firstArrayElement(a = []) {
		if(a.length > 0) return a[0];
		return false;
	}

	function getActiveDiscounts(data) {
		const activeDiscounts = [],
			discountTagPrefixes = window.promotions
				? Object.values(window.promotions).filter(promo => promo.status === true && promo.tag).map(promo => promo.tag.toLowerCase())
				: [],
			foundDiscountTags = data.tags.filter(tag => discountTagPrefixes.some(prefix => tag.toLowerCase().includes(prefix)));

		for(discountTag of foundDiscountTags) {
			const discountTagLowercased = discountTag.toLowerCase(),
				discountPrefix = firstArrayElement(discountTagPrefixes.filter(prefix => discountTagLowercased.includes(prefix)));
			let discountSettings = [],
				discountSku = '';
			if(discountPrefix !== false) {
				discountSettings = discountTagLowercased.replace(discountPrefix, '').split('_');
				[discountSku] = discountSettings;
			}
			const currentVariant = firstArrayElement(data.variants.filter(variant => variant.sku.toLowerCase() == discountSku)),discountDetails = formatDiscountValue({
					discountPrefix,
					discountSettings,
					price: currentVariant ? currentVariant.price : data.price_min});

			activeDiscounts.push(discountDetails);
		}

		activeDiscounts.sort( (a, b) => a.amount - b.amount );
		return activeDiscounts;
	}



	function buildCustomSaleLabel(data) {
		const activeDiscounts = getActiveDiscounts(data);

		// Build Sale label
		let saleLabel = '';
		if(activeDiscounts.length > 0) {
			if(activeDiscounts[0].changePrice) {
				const { amount } = activeDiscounts[0];
				changePrice = true; // global variable
				discountAmount = amount; // global variable
			}
			if (activeDiscounts[0].text) {
				saleLabel = boostPFSTemplate.customSaleLabelHtml.replace(/{{saleText}}/g, activeDiscounts[0].text);
			}
		}
		return saleLabel;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
		wishlistModel.addListeners();
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ('.collection-filters__sort').change(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};

	//Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('displayTypeHtml')) {
			var itemHtml = '';
			if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
				itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text">Grid</span></a>';
				itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">List</span></a>';
			} else {
				itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text">Grid</span></a>';
				itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">List</span></a>';
			}

			itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);
			html = boostPFSTemplate.displayTypeHtml.replace(/{{displayTypeItems}}/g, itemHtml);
		}
		return html;
	};

	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in arr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		// Shopify.theme.jsAddToCart.listenAll();
		Shopify.theme.jsProductCard.listen();
		Shopify.theme.jsProductCard.showForm();
		Shopify.theme.jsProductCard.showMobileForm();
		Shopify.theme.jsProductCard.closeForm();
		Shopify.theme.jsProductCard.closeMobileForm();
		data.forEach(item => {
			let element = document.querySelector('[data-id="' + item.id +'"]');
			Shopify.theme.jsAddToCart.listenOne(element);

			//Recharge Subscription icon
			let productDataUrl = '/products/' + item.handle + '.js';
			const productData = fetch(productDataUrl)
				.then((response) => response.json())
				.catch(e => {console.error(e);});

			const checkRecharge = async () => {
				let productDataJson = await productData;
				let rechargeSubscription = false;
				productDataJson.selling_plan_groups.forEach(selling_plan_group => {
					selling_plan_group.selling_plans.forEach(selling_plan => {
						if (selling_plan.name.includes('Delivered every')) {
							rechargeSubscription = true;
							return true;
						}
					})
				})
				if (rechargeSubscription) {
					let element = document.querySelector('[data-id="' + item.id +'"] .recharge-subscription-icon');
					element.classList.remove('hidden');
				}
			}

			checkRecharge();
		})

		function changeHomeDeliveryQty(homeDeliveryQty, select) {
			if (homeDeliveryQty) {
				let propHomeDelivery = select.closest('form').querySelector('input[name="properties[_home_delivery_quantity]"]');
				let propTag = select.closest('form').querySelector('input[name="properties[_tags]"]');
				if (propHomeDelivery) {
					propHomeDelivery.value = homeDeliveryQty;
				}

				if (propTag) {
					let tags = propTag.value.split(',');
					let tagsResult = '';
					tags.forEach(tag => {
						let result = tag;
						if (tag.includes('homeDeliveryQuantity-')) {
							result = 'homeDeliveryQuantity-' + homeDeliveryQty;
						}
						if (tagsResult == '') {
							tagsResult = result;
						} else {
							tagsResult = "," + result;
						}
					});
					propTag.value = tagsResult;
				}
			}
		}

		let formSelects = document.querySelectorAll('.product-form--modal .product-select-variant');
		if (formSelects.length > 0) {
			formSelects.forEach(select => {
				select.addEventListener('change', (e) => {
					let homeDeliveryQty = select.querySelector('option:checked').getAttribute('data-home-delivery-qty');
					changeHomeDeliveryQty(homeDeliveryQty, select);
				})
			});
		}

		let multiOptions = document.querySelectorAll('.product-form--modal .product-card--options');
		if (multiOptions.length > 0) {
			multiOptions.forEach(multiOption => {
				multiOption.addEventListener('change', (e) => {
					let formSelect = multiOption.closest('form').querySelector('.product-select-variant');
					if (formSelect) {
						let homeDeliveryQty = formSelect.querySelector('option:checked').getAttribute('data-home-delivery-qty');
						changeHomeDeliveryQty(homeDeliveryQty, formSelect);
					}
				});
			});
		}
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var productCountText;
		if (data.total_product === 1 ) {
			productCountText = ' product';
		} else if (data.total_product > 1) {
			productCountText = ' products';
		}
		jQ('.boost-pfs-filter-total-product').html(data.total_product + productCountText);
	};

	FilterOptionItem.prototype.beforeRender = function () {
		this.countLabel = this.docCount;
	}

	FilterApi.beforeCall = function (eventType, eventInfo) {
		if (Utils.isCollectionPage() || Utils.isSearchPage()) {
			const backorderValue = localStorage.getItem('backorder-filter-value') || 'off';
			Globals.queryParams.pf_t_show_special_order_products = [`backorder:${backorderValue}`];
			localStorage.setItem('backorder-filter-value', backorderValue);
		}
	};


	function __checkExistFilterOptionParam() {
		for (var t in Globals.queryParams) {
			if (t == 'pf_t_show_special_order_products')
				continue;

			if (t.indexOf("pf_") > -1)
				return true;
		}

		return false;
	}
	RobotsMeta.prototype.isRender = function() {
		return Settings.getSettingValue('general.enableSeo') &&
			!jQ(this.selecor.robots).length &&
			(
				this.currentCollection.indexOf(this.settings.boostCollection) == 0 ||
				__checkExistFilterOptionParam() ||
				(Globals.queryParams.q && !Utils.isSearchPage())
			);
	}

	/************************** END BUILD TOOLBAR **************************/
})();